import { appConfig } from '@newo/app-config';
import { isEnvExist } from '@/utils/isEnvExist';

function getSharedConfig() {
	return appConfig.getSharedConfig();
}

function getCreatorConfig() {
	return appConfig.getCreatorConfig();
}

export const PATHS = {
	index: '/',
	remoteCreatorIndex: '/agent-creator',
	creatorIndex: '/creator',
	agentTraining: '/creator/training',
	customerForm: '/creator/customer-form',
	agentSuccess: '/creator/success',
	creatorVoice: '/creator/voice',
	partnerPortal: '/partner/{:idn}/customers',
	businessConfirmation: '/creator/business-confirmation'
};

export const PARTNER_IDN = getCreatorConfig().partnerCustomerIdn ?? '';
export const VITE_API_HOST = getSharedConfig().apiHost ?? '';
export const CLIENT_SECRET = getCreatorConfig().creatorClientSecret ?? '';

export const PARTNER_INDUSTRY = getCreatorConfig().partnerIndustry ?? '';
export const IS_MICRO_FRONTEND_APP = getCreatorConfig().buildMode === 'remote';
export const FALLBACK_INDUSTRY = 'sales_industry';

export const BASE_PATH = (getCreatorConfig().basePath ?? '').replace(/\/$/, '');

export const runtimeConfig = {
	get creatorClientSecret() {
		return getCreatorConfig().creatorClientSecret ?? '';
	},
	get chatApiEndpoint() {
		return getSharedConfig().chatApi ?? '';
	},
	get apiHostEndpoint() {
		return getSharedConfig().apiHost ?? '';
	},
	get cmsApiUrl() {
		return getSharedConfig().cmsApiUrl ?? '';
	},
	get partnerIdn() {
		return getSharedConfig().partnerIdn ?? '';
	},
	get googleApiKey() {
		const googleApiKey = getCreatorConfig().googleApiKey ?? '';
		return isEnvExist(googleApiKey) ? googleApiKey : '';
	},

	get whiteLabelPortalUrl() {
		return getCreatorConfig().wlPortalUrl ?? '';
	},

	get isRemoteBuild() {
		const buildMode = getCreatorConfig().buildMode;
		return isEnvExist(buildMode) ? buildMode === 'remote' : false;
	},

	get isE2E() {
		return Boolean(getCreatorConfig().e2e);
	}
};

export const USER_AGENT_VALUE = 'Ordinary agent creator';
